var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSayLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 15,
    viewBox: "0 0 62 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.607.184v.343l-.052.058-8.834 9.54v4.563h-4.05v-4.563L39.785.527V.184h4.533l.027.03 6.347 7.017L57.068.184h4.539zm-52.5 5.45c-3.906 0-5.27-.053-5.27-1.195 0-1.006 1.337-1.33 5.664-1.33 4.55 0 8.204 1.21 8.204 1.21l.282-.094V1.167S14.625 0 9.422 0C4.488 0 0 .754 0 4.957c0 4.144 3.247 4.2 10.323 4.2 3.553 0 5.23-.015 5.23 1.221 0 1.137-2.028 1.469-6.29 1.469C3.59 11.845.356 10.398.356 10.398l-.276.138v3.194l.118.036c2.432.768 5.709 1.19 9.225 1.19 6.986 0 9.965-1.055 9.965-4.914.001-3.9-2.735-4.409-10.282-4.409h.002zM34.271.184l9.297 14.166v.339h-4.311l-1.791-2.791H26.333l-1.79 2.791h-4.316v-.334L29.528.186h4.743zm-5.953 8.616h7.163L31.9 3.249l-3.582 5.552z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSayLogo);
export default __webpack_public_path__ + "static/media/say-logo.54fe6c0fcd4a9e3099bb05b09768224a.svg";
export { ForwardRef as ReactComponent };